<template>
  <div class="password-change-container">
    <el-card class="password-change-card">
      <template #header>
        <h2 class="card-header">修改密码</h2>
      </template>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            v-model="form.oldPassword"
            :type="oldPasswordInputType"
            placeholder="请输入旧密码"
          >
            <template #suffix>
              <div @click="() => togglePassword(1)" class="showPassword">
                <!-- 自定义眼睛图标，切换显示和隐藏密码 -->
                <icon-svg v-if="showOldPassword" name="eye-o" class="text-[#c0c4cc] text-16px" />
                <icon-svg v-else name="closed-eye" class="text-[#c0c4cc] text-16px" />
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="form.newPassword"
            :type="newPasswordInputType"
            placeholder="请输入新密码"
          >
            <template #suffix>
              <div @click="() => togglePassword(2)" class="showPassword">
                <!-- 自定义眼睛图标，切换显示和隐藏密码 -->
                <icon-svg v-if="showNewPassword" name="eye-o" class="text-[#c0c4cc] text-16px" />
                <icon-svg v-else name="closed-eye" class="text-[#c0c4cc] text-16px" />
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            :type="confirmPasswordInputType"
            placeholder="请再次输入新密码"
          >
            <template #suffix>
              <div @click="() => togglePassword(3)" class="showPassword">
                <!-- 自定义眼睛图标，切换显示和隐藏密码 -->
                <icon-svg v-if="showCofirmPassword" name="eye-o" class="text-[#c0c4cc] text-16px" />
                <icon-svg v-else name="closed-eye" class="text-[#c0c4cc] text-16px" />
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit" :loading="loading" class="submit-button" @click="onSubmit">
            提交
          </el-button>
        </el-form-item>
        <div class="logoutText">
          <el-button type="text" style="padding: 0;" @click="onLogout">退出登录</el-button>
          <span @click="toForget">忘记密码</span>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { modifyPassword } from '@/api/global';
import { getToken } from '@/utils/auth';

export default {
  data() {
    return {
      loading: false,
      showOldPassword: true,
      showNewPassword: true,
      showCofirmPassword: true,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    };
  },
  computed: {
    ...mapGetters('account', [
      'account',
    ]),
    oldPasswordInputType() {
      return this.showOldPassword ? 'text' : 'password';
    },
    newPasswordInputType() {
      return this.showNewPassword ? 'text' : 'password';
    },
    confirmPasswordInputType() {
      return this.showCofirmPassword ? 'text' : 'password';
    },
    rules() {
      return {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
        newPassword: [
          { required: true, validator: this.validatePass, trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
        confirmPassword: [
          { required: true, validator: this.validatePass2, trigger: 'blur' },
          { min: 6, max: 30, trigger: 'change', message: '请输入6至30位的密码' },
        ],
      };
    },
  },
  mounted() {
    if (!getToken() || !this.account?.userId) {
      this.$router.replace('/login');
    }
  },
  methods: {
    ...mapActions('account', [
      'logout',
    ]),
    togglePassword(type) {
      if (type === 1) {
        this.showOldPassword = !this.showOldPassword;
      } else if (type === 2) {
        this.showNewPassword = !this.showNewPassword;
      } else if (type === 3) {
        this.showCofirmPassword = !this.showCofirmPassword;
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.confirmPassword !== '') {
          if (this.$refs.formRef) {
            this.$refs.formRef.validateField('confirmPassword');
          }
        }
        callback();
      }
    },
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    async changePassword() {
      try {
        if (this.loading) return;
        this.loading = true;
        await modifyPassword({ userId: this.account?.userId, ...this.form });
        this.loading = false;
        this.$alert('密码修改成功，请重新登录！', '操作成功', {
          confirmButtonText: '好的',
          showCancelButton: false,
          showClose: false,
          callback: async () => {
            await this.logout();
            this.$router.replace('/login');
          },
        });
      } catch (error) {
        this.loading = false;
      }
    },
    onSubmit() {
      if (!this.$refs.formRef) return;

      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.changePassword();
        }
      });
    },
    async onLogout() {
      await this.logout();
      this.$router.replace('/login');
    },
    async toForget() {
      await this.logout();
      this.$router.replace({
        name: 'ForgotPwd',
      });
    },
  },
};
</script>

<style scoped>
.password-change-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  position: relative;
  background-color: #f0f2f5;
}
.password-change-card {
  width: 100%;
  max-width: 424px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  text-align: center;
  font-weight: bold;
  color: white;
    font-size: 24px;
    color: #232323;
  width: 100%;
}
:deep(.el-input__suffix-inner) {
  display: inline-block;
  height: 100%;
}
.showPassword {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.submit-button {
  width: 100%;
  font-size: 16px;
  border-radius: 8px;
  height: 38px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logoutText {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

:deep(.el-card__body) {
  padding: 20px;
}
:deep(.el-form-item) {
  margin-bottom: 18px;
}
:deep(.el-form-item__label) {
  margin-bottom: 8px;
  line-height: 22px;
  padding: 0 12px 0 0;
}

:deep(.el-input__inner) {
  height: 40px;
}

:deep(.el-input__inner) {
  height: 40px;
}

@media (max-width: 480px) {
  .password-change-card {
    max-width: 90%;
  }
}
</style>
